import React, { useState, useEffect } from 'react';
import ReactCalendar from 'react-calendar';
import { useDispatch } from 'react-redux';

import config from '../../config/config';
import '../../styles/lib/calendar.scss';
import { submitBookingInfo } from '../../state/actions/service';

function BookingCalendar() {
  const isCalendarDisabled = (date) => {
    const lowestDate = new Date();
    lowestDate.setDate(lowestDate.getDate() + 1);

    return lowestDate > date || date.getDay() === 6 || date.getDay() === 0;
  };

  const getFirstFreeDate = async () => {
    let currentDate = new Date();

    while (await isCalendarDisabled(currentDate)) {
      currentDate.setDate(currentDate.getDate() + 1);
    }

    onDateChange(currentDate);

    return currentDate;
  };

  const [date, onDateChange] = useState(null);
  const [selectedSlot, onSlotChange] = useState(config.serviceSlots[0]);
  const dispatch = useDispatch();

  // Lowest date to include today for calendar
  const lowestDate = new Date();
  lowestDate.setDate(lowestDate.getDate() + 1);

  useEffect(() => {
    dispatch(
      submitBookingInfo({
        date,
        service_slot_id: selectedSlot.id,
        service_slot_name: config.serviceSlots.find((s) => s.id === selectedSlot.id)?.name,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, selectedSlot]);

  useEffect(() => {
    if (date) {
      date.setHours(date.getHours() + 20);
      dispatch(
        submitBookingInfo({
          date,
          service_slot_id: selectedSlot.id,
          service_slot_name: config.serviceSlots.find((s) => s.id === selectedSlot.id)?.name,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  useEffect(() => {
    getFirstFreeDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <label class="input-label calendar-label">Välj dag och tid för inlämning.</label>
      <ReactCalendar
        defaultView="month"
        next2Label=""
        locale="sv"
        showNeighboringMonth={false}
        prev2Label=""
        tileDisabled={({ date }) => isCalendarDisabled(date)}
        formatShortWeekday={(_, date) => ['S', 'M', 'T', 'O', 'T', 'F', 'L'][date.getDay()]}
        onChange={onDateChange}
        value={date}
      />
      <div className="row">
        {config.serviceSlots.map((slot) => {
          return (
            <ServiceSlot
              key={slot.id}
              slot={slot}
              isSelected={selectedSlot === slot}
              onChange={onSlotChange}
            />
          );
        })}
      </div>
      <p className="slot-tip">
        Öppettider Måndag - Fredag: City Kl 9 – 17 (lunchstängt 12-13) Liljeholmen Kl 10 – 18.
      </p>
      <hr className="line" />
    </div>
  );
}

function ServiceSlot({ slot, isSelected, onChange }) {
  return (
    <div
      className={`col service-slot ${isSelected && 'service-slot-active'}`}
      onClick={() => onChange(slot)}
    >
      {slot.name}
    </div>
  );
}

export default BookingCalendar;
